import * as React from "react";
import style from "./index.module.scss";
import { Breadcrumb, Button, Card, Spin, Tooltip } from "antd";
import { useHistory } from "react-router-dom";
import { useState } from "react";
import NavBar from "./component/NavBar";
import { BiUndo } from "react-icons/bi";
import OrderPlanList from "./component/OrderPlanList";
import useRequest from "Utils/useRequest";
import { getExperimentInfo } from "API/navExperiment";
import { useParams } from "react-router-dom";
import CustomEmpty from "../../../../components/CustomEmpty";
import { ExperiNavState } from "../../../../API/navExperiment";
import { SubLayoutHeader } from "../../../../components/Layouts/SubLayout/Component/SubLayoutHeader";

export default function ExperimentDetail() {
    const history = useHistory();
    const [mark, setMark] = useState<number>(ExperiNavState.introduction);
    const { experimentId } = useParams<{ experimentId: string }>();

    const [data, { loading }] = useRequest(
        () => getExperimentInfo(experimentId),
        {},
        [experimentId]
    );

    const title = (
        <div className={style.head}>
            <div>
                <Tooltip title={data?.projectName} placement="bottomLeft">
                    <span className={style.courseTitle}>
                        {data?.projectName}
                    </span>
                </Tooltip>
                <Button
                    size="small"
                    className={style.goBack}
                    onClick={() => history.goBack()}>
                    <BiUndo size={16} />
                    返回
                </Button>
            </div>
        </div>
    );

    return (
        <div className={style.root}>
            <SubLayoutHeader title={data?.projectName} />

            <Breadcrumb separator=">">
                <Breadcrumb.Item href="/experiment">实验项目</Breadcrumb.Item>
                <Breadcrumb.Item>
                    <a href="">{data?.projectName}</a>
                </Breadcrumb.Item>
            </Breadcrumb>

            <Spin spinning={loading}>
                <Card
                    title={title}
                    bordered={false}
                    className={style.container}>
                    <NavBar
                        mark={mark}
                        onChange={(val: number) => setMark(val)}
                    />

                    <div className={style.content}>
                        {mark === ExperiNavState.introduction && (
                            <div className={style.introduce}>
                                {data?.projectIntroduce ? (
                                    data?.projectIntroduce
                                ) : (
                                    <CustomEmpty
                                        style={{ padding: "200px 0" }}
                                        description="无项目介绍"
                                    />
                                )}
                            </div>
                        )}

                        {mark === ExperiNavState.software && (
                            <div className={style.introduce}>
                                {data?.softWare ? (
                                    data?.softWare
                                ) : (
                                    <CustomEmpty
                                        style={{ padding: "200px 0" }}
                                        description="暂无安装信息"
                                    />
                                )}
                            </div>
                        )}
                        {mark === ExperiNavState.planList && (
                            <OrderPlanList dataDetail={data} />
                        )}
                    </div>
                </Card>
            </Spin>
        </div>
    );
}
